import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  show(event) {
    const button = event.currentTarget
    const subscriberId = button.dataset.subscriberId
    const subscriberType = button.dataset.subscriberType
    
    // Create a container for the modal
    const modalContainer = document.createElement('div')
    modalContainer.setAttribute('data-controller', 'move-list-modal')
    modalContainer.setAttribute('data-move-list-modal-subscriber-id-value', subscriberId)
    modalContainer.setAttribute('data-move-list-modal-subscriber-type-value', subscriberType)
    
    // Append to body
    document.body.appendChild(modalContainer)
  }
}